import { EditOutlined, FileDownload, UploadFile } from "@mui/icons-material";
import {
	Avatar,
	Grid,
	IconButton,
	Stack,
	Tooltip,
	Typography,
} from "@mui/material";
import { debounce } from "lodash";
import MUIDataTable from "mui-datatables";
import { useEffect, useMemo, useState } from "react";
import { downloadExcel, getAllBrand } from "../../apis/Brand";

export default function DataTable({
	handleEdit,
	setIsUploadDrawerOpen,
	setSelectedBrand,
}) {
	const [data, setData] = useState([]);
	const [page, setPage] = useState(0);

	const [searchText, setSearchText] = useState("");

	const [count, setCount] = useState(0);
	const [rowsCount, setRowsCount] = useState(10);

	const handleDownload = async (id) => {
		await downloadExcel(id);
	};

	const handleSearchChange = useMemo(
		() => debounce((searchText) => {
			setSearchText(searchText);
		}, 500),
		[]
	);

	useEffect(() => {
		getAllBrand(rowsCount, page + 1, { search: searchText }).then((res) => {
			setData(res.results);
			setCount(res.count);
		});
	}, [page, rowsCount, searchText]);

	const columns = [
		{
			name: "id",
			label: "Id",
			options: {
				filter: false,
				sort: true,
				setCellProps: () => ({ sx: { textAlign: "right" } }),
				// customBodyRender: (value, tableMeta, updateValue) => {
				// 	// console.log("yes", tableMeta);
				// 	return tableMeta.rowIndex + 1;
				// },
			},
		},

		{
			name: "name",
			label: "Name",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
						<Typography variant="p" component={"p"}>
							{value}
						</Typography>
					);
				},
			},
		},
		{
			name: "seller_market",
			label: "Seller Market",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return <Typography variant="p">{value}</Typography>;
				},
			},
		},

		{
			name: "logo",
			label: "Logo",
			options: {
				filter: true,
				sort: true,

				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return (
						<Avatar
							alt="Brand Logo"
							src={value?.file}
							sx={{ bgcolor: "primary.main", color: "white" }}
						>
							{data[tableMeta.rowIndex].name.slice(0, 1)}
						</Avatar>
					);
				},
			},
		},

		{
			name: "",
			label: "Action",
			options: {
				filter: false,
				sort: true,
				viewColumns: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const { rowIndex } = tableMeta;
					const row = data[rowIndex];
					return (
						<Stack direction={"row"}>
							<IconButton
								color="primary"
								onClick={() => handleEdit(row)}
							>
								<EditOutlined />
							</IconButton>
							{/* <IconButton
								color="secondary"
								// onClick={() =>
								// 	handleDelete(page * rowsCount + i)
								// }
							>
								<DeleteOutline />
							</IconButton> */}
							<IconButton
								color="primary"
								onClick={() => handleDownload(row.id)}
							>
								<Tooltip
									title="Download Products Template"
									arrow
								>
									<FileDownload />
								</Tooltip>
							</IconButton>
							<IconButton
								color="primary"
								onClick={() => {
									setSelectedBrand(row);
									setIsUploadDrawerOpen(true);
								}}
							>
								<Tooltip title="Upload Products" arrow>
									<UploadFile />
								</Tooltip>
							</IconButton>
						</Stack>
					);
				},
			},
		},
	];

	const options = {
		jumpToPage: true,
		selectableRows: "none",
		download: false,
		filter: false,
		// filterType: "multiselect",
		serverSide: true,
		print: false,
		count: count,
		page: page,
		rowsPerPage: rowsCount,
		rowsPerPageOptions: [10, 25, 100],
		onChangePage(currentPage) {
			setPage(currentPage);
		},
		onChangeRowsPerPage(numberOfRows) {
			setRowsCount(numberOfRows);
		},
		onSearchChange: handleSearchChange,
		onColumnSortChange: (changedColumn, direction) => {
			// setSortingValues(
			// 	direction === "desc" ? `-${changedColumn}` : `${changedColumn}`
			// );
			// setPage(0)
			// setSortFields(temp);
		},

		// onTableChange: (action, tableState) => {
		// 	switch (action) {
		// 		case "sort":
		// 			sortTable(tableState.page, tableState.sortOrder);
		// 			break;
		// 		default:
		// 			console.log("action not handled.");
		// 	}
		// },
	};

	return (
		<Grid container justifyContent="center">
			<Grid item md={8}>
				<MUIDataTable data={data} columns={columns} options={options} />
			</Grid>
		</Grid>
	);
}
